import React, { useLayoutEffect, useRef, useState } from "react"
import { CustomFilterConfig, DataTableFilterState } from "../../Tables/DataTable/DataTable"
import { ColumnConfig } from "../../../types"
import { Table } from "simplygrow-ui"
import { TableService } from "../../../services"
import { TABLE_ROW_HEIGHT } from "../../../constants/table"

export type PPERequestDetailsDataSchema = {
  id?: string
  sk?: string
  item: string
  sku: string
  size: string
  // qty: number
  requestedFor: string
  available: string
}

interface PPERequestDetailsProps {
  data: PPERequestDetailsDataSchema[]
  style?: React.CSSProperties
}

const tableService = new TableService()

const PpeRequestDetails = (props: PPERequestDetailsProps) => {
  const tableRef = useRef<HTMLDivElement>(null)

  const [tableHeight, setTableHeight] = useState<number>(500)

  useLayoutEffect(() => {
    if (tableRef.current) {
      const tableTopY = tableRef.current.getBoundingClientRect().top
      const browserWindowHeight = window.innerHeight
      setTableHeight(browserWindowHeight - tableTopY)
    }
  }, [tableRef.current])

  let tableColumnConfig: ColumnConfig[] = [
    { key: "item", label: "Item", sizeFactor: 1 },
    { key: "sku", label: "SKU", sizeFactor: 1 },
    { key: "size", label: "Size", sizeFactor: 1 },
    { key: "requestedFor", label: "Requested for", sizeFactor: 1 },
    { key: "available", label: "Available", sizeFactor: 1 },
    // { id: 'issuedPrice', label: 'Issued price', sizeFactor: 1 },
  ]

  const tableColumnDef = tableService.convertPfColumnConfigToGridColDef(tableColumnConfig)
  return (
    <div ref={tableRef} style={{ width: "100%" }}>
      <Table rows={props.data} columns={tableColumnDef} tableHeight={tableHeight} rowHeight={TABLE_ROW_HEIGHT} />
    </div>
  )
}

export default PpeRequestDetails
